import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import conf from 'conf/conf';
import { useModal } from 'context/ModalContext';
import { useSettings } from 'context/SettingsContext';
import NeedPay from '../NeedPay';

const useNeedPay = () => {
    const { showDlg, hideDlg } = useModal();
    const { settings } = useSettings();
    const { t } = useTranslation('Tariff');
    const navigate = useNavigate();

    const needPay = (): boolean => {
        if (!conf.saasMode) return false;
        if (Number(settings?.account?.tariff ?? -1) !== 0) return false;

        showDlg({
            type: 'info',
            title: t('needPayTitle'),
            text: <NeedPay />,
            buttons: [
                {
                    title: t('needPayAction'),
                    variant: 'primary',
                    handleClick: () => {
                        hideDlg();
                        navigate('/tariff');
                    },
                },
            ],
        });

        return true;
    };

    return { needPay };
};

export default useNeedPay;
